'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTestRenderer = require('react-test-renderer');

var _reactTestRenderer2 = _interopRequireDefault(_reactTestRenderer);

var _xstate = require('xstate');

var _graph = require('xstate/lib/graph');

var _utils = require('./utils');

var _withStatechart = require('./withStatechart');

var _withStatechart2 = _interopRequireDefault(_withStatechart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var testStatechart = function testStatechart(config, Component) {
  var channel = config.channel,
      statechart = config.statechart;

  var machine = (0, _xstate.Machine)(statechart);
  var paths = (0, _graph.getShortestPaths)(machine);

  Object.keys(paths).forEach(function (key) {
    var _ref;

    var initialData = (_ref = config) != null ? (_ref = _ref.fixtures) != null ? _ref.initialData : _ref : _ref;
    var StateMachine = (0, _withStatechart2.default)(statechart, { channel: channel })(Component);
    var renderer = _reactTestRenderer2.default.create(_react2.default.createElement(StateMachine, { initialData: initialData }));
    var instance = renderer.getInstance();

    paths[key].forEach(function (_ref3) {
      var _ref2;

      var event = _ref3.event,
          state = _ref3.state;

      var fixtures = (_ref2 = config) != null ? (_ref2 = _ref2.fixtures) != null ? (_ref2 = _ref2[state]) != null ? _ref2[event] : _ref2 : _ref2 : _ref2;

      instance.handleTransition(event, fixtures);
    });

    var _getContextValue = (0, _utils.getContextValue)(instance.getChildContext(), channel),
        machineState = _getContextValue.machineState;

    expect(renderer.toJSON()).toMatchSnapshot(machineState);
  });
};

exports.default = testStatechart;


//////////////////
// WEBPACK FOOTER
// ./~/react-automata/lib/testStatechart.js
// module id = 1171
// module chunks = 168707334958949